module.exports = __webpack_public_path__ + "img/post-preview.ecc8da24.png";